import { Controller } from "@hotwired/stimulus"

// A small overflow menu for table rows: a button that toggles a panel, which
// closes on an outside click or on Escape.
//
// Visibility is driven by the `hidden` attribute rather than a class, so the
// menu is closed for assistive technology too, not merely painted out of view.
export default class extends Controller {
  static targets = ["button", "menu"]

  connect() {
    this.closeOnOutsideClick = this.closeOnOutsideClick.bind(this)
    this.closeOnEscape = this.closeOnEscape.bind(this)
  }

  // Turbo reuses the DOM across navigations, so listeners added on open must be
  // removed here as well — otherwise a disconnected row keeps handling clicks.
  disconnect() {
    this.teardown()
  }

  toggle(event) {
    event.preventDefault()
    this.menuTarget.hidden ? this.open() : this.close()
  }

  open() {
    this.menuTarget.hidden = false
    this.buttonTarget.setAttribute("aria-expanded", "true")
    document.addEventListener("click", this.closeOnOutsideClick)
    document.addEventListener("keydown", this.closeOnEscape)
  }

  close() {
    this.menuTarget.hidden = true
    this.buttonTarget.setAttribute("aria-expanded", "false")
    this.teardown()
  }

  closeOnOutsideClick(event) {
    if (this.element.contains(event.target)) return

    this.close()
  }

  closeOnEscape(event) {
    if (event.key !== "Escape") return

    this.close()
    this.buttonTarget.focus()
  }

  teardown() {
    document.removeEventListener("click", this.closeOnOutsideClick)
    document.removeEventListener("keydown", this.closeOnEscape)
  }
}
